import { useEffect, useState } from 'react';
import karliMason from '../../../assets/website/images/Karli-Mason.jpg'
import stefanyWedge from '../../../assets/website/images/Stefany-Wedge.jpg'
import { GetCMSDetails } from '../services/cms.services';
import OutStorySection from './outStory';
import Services from './services';
import { Placeholder } from 'rsuite';


function WebsiteAboutPage() {
  const [pageData, setPageData] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    setDataLoaded(false);
    GetCMSDetails("why-babe-exists").then((response) => {
      if (response.success) {
        setPageData(response.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setDataLoaded(true);
    });
  }, []);

  const [pageFounderData, setPageFounderData] = useState(false);
  const [founderDataLoaded, setFounderDataLoaded] = useState(false);
  useEffect(() => {
    setFounderDataLoaded(false);
    GetCMSDetails("founder-desc").then((response) => {
      if (response.success) {
        setPageFounderData(response.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setFounderDataLoaded(true);
    });
  }, []);

  return (
    <main>
      {/* <section className="about-banner-section section-padding">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text section-head">
              <h1 className="h1-headline">
                Supporting women at every stage, because, babe, it ain’t easy
              </h1>
            </div>
          </div>
        </div>
      </section> */}
      <section className="banner-scetion-padding">
        <div className="container">
          <h1 className="heading-1 main-heading-2 text-center">Meet the founders</h1>
        </div>
      </section>

      {/* <section className="babe-born-section">
        <din className="container">
          <div className="text-box">
            <h2 className="h2-headline">babe. was born for you.</h2>
            <p className="body-1">
            babe comes to you, a platform connecting women to trusted, on-demand services. Inclusive of fertility support with egg freezing and IVF injection concierge, pregnancy & postpartum self-care, reliable childcare sourcing, and elder caregiving. babe prioritizes the wellbeing, support, and empowerment of women.{" "}
            </p>
            <p className="body-1">
            Our mission is to be innovators for women’s wellness, champions for your success through scalable access to what you really need (so you can do it all, or not, or whatever you want - babe, we don’t judge), and help you find your village.{" "}
            </p>
          </div>
        </din>
      </section> */}
      <section className="meet-founders section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={karliMason}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Karli Mason</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    A former wellness editor turned entrepreneur, Amara created
                    babe to be the kind of space she wished existed during her
                    own life transitions
                  </p> */}
                </figcaption>
              </div>
            </div>

            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={stefanyWedge}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Stefany Wedge</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    With a background in integrative health and women’s
                    advocacy, Nyla is the heart behind babe’s wellness
                    initiatives.
                  </p> */}
                </figcaption>
              </div>
            </div>

            {
              founderDataLoaded &&
              <div className='col-12'>
                {
                  pageFounderData?.description ?
                  <div className="text-center w-100 mx-auto text-color-primary pt-3" dangerouslySetInnerHTML={{ __html: pageFounderData?.description }}></div> : null
                }
              </div>
            }
          </div>
        </div>
      </section>

      <section className="Why-babe-exists section-padding">
        <div className="container">
          <div className="Why-babe-wrap">
            <div className="Why-babe-in">
              {
                dataLoaded ?
                  <>
                    <div className="text-box">
                      <h2 className="h2-headline">{pageData?.title}</h2>
                    </div>
                    {pageData?.description ? <div className='row align-items-center justify-content-center text-center' dangerouslySetInnerHTML={{ __html: pageData?.description }}></div> : null}
                    {/* <div className="col-md-5">
                        <div className="our-mission-box">
                          <h4 className="h4-headline">Our Mission</h4>
                          <h6 className="h6-headline">
                            babe is here to walk alongside women through every messy,
                            beautiful, complicated stage of life. Whether it's
                            navigating new motherhood, identity shifts, burnout, or
                            bold beginnings — we offer real support, heartfelt
                            community, and tools designed for you.
                          </h6>
                        </div>
                      </div>

                      <div className="col-md-1 d-none d-md-block">
                        <div className="vertical-divider"></div>
                      </div>

                      <div className="col-md-5">
                        <div className="our-mission-box">
                          <h4 className="h4-headline">Our Vision</h4>
                          <h6 className="h6-headline">
                            We imagine a world where women no longer have to “power
                            through” alone — where asking for help is celebrated, and
                            being in transition doesn’t mean being invisible. We want
                            every woman to feel seen, supported, and rooted in her
                            worth — every step of the way.
                          </h6>
                        </div>
                      </div> */}
                  </>
                  :
                  <div className='w-100 website-placeholder '>
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} className='mb-3' rowHeight={60} active rows={1} />
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} rowHeight={25} active rows={5} />
                  </div>
              }
            </div>
          </div>
        </div>
      </section>

      {/* <OutStorySection />

      <Services /> */}


    </main>
  );
}

export default WebsiteAboutPage;
